import React from "react";

const Enterprise = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 6.24994C15.0015 5.74998 14.903 5.25477 14.7103 4.79344C14.5176 4.33211 14.2345 3.91397 13.8779 3.56362C13.5212 3.21327 13.0981 2.93778 12.6334 2.75335C12.1686 2.56893 11.6718 2.47929 11.1719 2.48971C10.672 2.50012 10.1793 2.61039 9.7227 2.81402C9.26609 3.01765 8.8548 3.31054 8.51303 3.67545C8.17127 4.04036 7.90592 4.46992 7.7326 4.93888C7.55927 5.40784 7.48148 5.90672 7.50378 6.40619C6.76903 6.59511 6.08691 6.94875 5.50907 7.44033C4.93123 7.93191 4.47283 8.54853 4.16859 9.2435C3.86434 9.93847 3.72223 10.6936 3.75302 11.4516C3.7838 12.2096 3.98668 12.9507 4.34628 13.6187C3.71401 14.1324 3.21681 14.7927 2.89796 15.5424C2.5791 16.292 2.44823 17.1082 2.51674 17.9199C2.58524 18.7317 2.85105 19.5144 3.29104 20.2C3.73102 20.8856 4.33186 21.4533 5.04128 21.8537C4.95368 22.5315 5.00596 23.22 5.19489 23.8768C5.38382 24.5336 5.7054 25.1447 6.13976 25.6724C6.57412 26.2 7.11205 26.633 7.72031 26.9446C8.32857 27.2563 8.99425 27.4399 9.67625 27.4841C10.3583 27.5284 11.0421 27.4323 11.6855 27.202C12.3289 26.9716 12.9183 26.6117 13.4172 26.1446C13.9161 25.6776 14.314 25.1131 14.5862 24.4863C14.8585 23.8594 14.9993 23.1834 15 22.4999V6.24994Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 6.24994C14.9985 5.74998 15.0971 5.25477 15.2898 4.79344C15.4825 4.33211 15.7655 3.91397 16.1222 3.56362C16.4789 3.21327 16.902 2.93778 17.3667 2.75335C17.8314 2.56893 18.3283 2.47929 18.8281 2.48971C19.328 2.50012 19.8207 2.61039 20.2773 2.81402C20.734 3.01765 21.1452 3.31054 21.487 3.67545C21.8288 4.04036 22.0941 4.46992 22.2675 4.93888C22.4408 5.40784 22.5186 5.90672 22.4963 6.40619C23.231 6.59511 23.9131 6.94875 24.491 7.44033C25.0688 7.93191 25.5272 8.54853 25.8315 9.2435C26.1357 9.93847 26.2778 10.6936 26.247 11.4516C26.2162 12.2096 26.0134 12.9507 25.6538 13.6187C26.286 14.1324 26.7832 14.7927 27.1021 15.5424C27.421 16.292 27.5518 17.1082 27.4833 17.9199C27.4148 18.7317 27.149 19.5144 26.709 20.2C26.269 20.8856 25.6682 21.4533 24.9588 21.8537C25.0464 22.5315 24.9941 23.22 24.8052 23.8768C24.6162 24.5336 24.2946 25.1447 23.8603 25.6724C23.4259 26.2 22.888 26.633 22.2797 26.9446C21.6715 27.2563 21.0058 27.4399 20.3238 27.4841C19.6418 27.5284 18.958 27.4323 18.3145 27.202C17.6711 26.9716 17.0817 26.6117 16.5828 26.1446C16.0839 25.6776 15.686 25.1131 15.4138 24.4863C15.1416 23.8594 15.0007 23.1834 15 22.4999V6.24994Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.75 16.25C17.7006 15.8808 16.7841 15.2087 16.1167 14.3188C15.4492 13.4288 15.0606 12.3608 15 11.25C14.9394 12.3608 14.5508 13.4288 13.8833 14.3188C13.2159 15.2087 12.2994 15.8808 11.25 16.25"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.9988 8.125C22.3013 7.60073 22.4724 7.01102 22.4975 6.40625"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.50366 6.40625C7.52838 7.01092 7.69907 7.60062 8.00116 8.125"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.34619 13.62C4.57487 13.4338 4.81957 13.2681 5.07744 13.125"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.9226 13.125C25.1805 13.2681 25.4252 13.4338 25.6539 13.62"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.50001 22.5C6.63855 22.5004 5.79159 22.2782 5.04126 21.855"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.9587 21.855C24.2084 22.2782 23.3615 22.5004 22.5 22.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Enterprise;
